/**
 * Back navigation button — left chevron, inherits text colour from parent
 * so it works on any surface (dark header, light card, etc.).
 *
 * Props:
 *   onClick    — click handler
 *   ariaLabel  — accessible name (default: "Go back")
 *   disabled   — disables interaction
 *   className  — extra classes on the root button
 */
import { FiChevronLeft } from 'react-icons/fi';

export default function BackButton({
  onClick,
  ariaLabel = 'Go back',
  disabled = false,
  className = '',
  ...props
}) {
  const classes = ['back-btn', className].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      {...props}
    >
      <FiChevronLeft size={20} aria-hidden="true" />
    </button>
  );
}
